var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-recommendation"},[_c('el-row',{staticClass:"flex-wrap",attrs:{"type":"flex"}},[_c('el-col',{attrs:{"span":24}},[_c('div',{staticClass:"meal"},[_c('div',{staticClass:"title"},[_c('p',[_vm._v(_vm._s(_vm.main))]),_c('span',[_vm._v(" "+_vm._s(_vm.sides))])])])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }